import Vue from 'vue'
export default () => {
  // 针对 el-input做的限制，只能输入正整数
  // <el-input v-model="vlaue"  v-Int />
  Vue.directive('Int', {
    bind: function (el) {
      const input = el.getElementsByTagName('input')[0]
      input.onkeyup = function (e) {
        if (input.value.length === 1) {
          input.value = input.value.replace(/[^0-9]/g, '')
        } else {
          input.value = input.value.replace(/[^\d]/g, '')
        }
        trigger(input, 'input')
      }
      input.onblur = function (e) {
        if (input.value.length === 1) {
          input.value = input.value.replace(/[^0-9]/g, '')
        } else {
          input.value = input.value.replace(/[^\d]/g, '')
        }
        trigger(input, 'input')
      }
    }
  })

  Vue.directive('clickoutside', {
    bind:function(el,binding){
      const handle = function(e){
        if(el.contains(e.target)) {
          return false
        }
        if(binding.expression){
          binding.value(e)
        }
      }

      document.addEventListener('click',handle)
    }
  })
}
const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents')
  e.initEvent(type, true, true)
  el.dispatchEvent(e)
}


// WEBPACK FOOTER //
// ./src/utils/directive.js